import React, { useState, useRef } from "react"
import { Avatar } from "@mui/material"
import { Col, Image, Modal, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import Messagetext from "./MessageText"
import ImageViewer from "react-simple-image-viewer"
import { getUserId } from "../../helpers/storage/user"
import QuillEditor from "../../components/helper/QuillEditor"
import { unlockMessagePaymentStart } from "../../store/actions/ChatAction"
import { formatMessageTime } from "../../helpers/date/messages"

import "./style_new.scss"
import Lock from "../../images_new/icon/lock.svg?react"
const defaultProfile = "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/default/profile_placeholder.jpg"

const MeessageItem = ({ message }) => {
  const [toggleMedia, setToggleMedia] = useState({ isOpen: false, file: null, type: null })

  const showMedia = (file, type) => {
    setToggleMedia({ isOpen: true, file, type })
  }

  const hideMedia = () => {
    setToggleMedia({ isOpen: false, file: null, type: null })
  }
  if (message.is_locked) {
    return <LockedMessage message={message} />
  }
  if (message.user_id === getUserId()) {
    return <SentMessage message={message} showMedia={showMedia} hideMedia={hideMedia} toggleMedia={toggleMedia} />
  } else {
    return <ReceivedMessage message={message} showMedia={showMedia} hideMedia={hideMedia} toggleMedia={toggleMedia} />
  }
}

const VideoPreviewModal = ({ videoFile, isOpen, onClose }) => {
  const videoRef = useRef(null)

  if (!isOpen) return null

  return (
    <Modal show={isOpen} onHide={onClose} centered size="lg">
        <video ref={videoRef} controls style={{ width: "100%", background:'transparent' }} autoPlay playsInline>
          <source src={videoFile} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
    </Modal>
  )
}

const LockedMessage = ({ message }) => {
  const dispatch = useDispatch()
  const messageUnlockPaymentWallet = useSelector((state) => state.chat.messageUnlockPaymentWallet)

  const onUnlockClicked = () => {
    dispatch(unlockMessagePaymentStart({ message_id: message.id.toString() }))
  }

  return (
    <>
      <li className="sentmsg mb-0">
        <div className="imgchat">
          <Avatar
            src={message.user?.picture}
            style={{ width: '39px', height: '39px', marginLeft: '10px' }}
            className=" img-fluid"
            alt='avtar'
          >
            <img
              src={defaultProfile}
              style={{ width: '72px', height: '72px' }}
              alt="profile"
            />
          </Avatar>
        </div>
        <div className="textchat">
          <div className="headingchat">
            <div
              className="locked-message"
            >
              <div className="text-center">
                <Lock fill="black" />
              </div>
            </div>
            <QuillEditor
              className='message-items'
              id={`message-item-editor-${message.id}`}
              placeholder=''
              value={message.text}
              readOnly={true}
            />
            <hr />
            <div>
              <button
                onClick={() => onUnlockClicked()}
                className={`button-primary w-100`}
                disabled={messageUnlockPaymentWallet.buttonDisable}
              >
                <div>
                  {messageUnlockPaymentWallet.loading &&
                    messageUnlockPaymentWallet.inputData?.message_id?.toString() === message.id.toString() ? (
                    <div className="btn-spinner" />
                  ) : (
                    <> Unlock Message for ${message.price}</>
                  )}
                </div>
              </button>
            </div>
            <span className="dateinfo mt-2">
              {message.is_read ? (
                <Image src="https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/bi_check-all.svg" alt='check_all icon' />
              ) : (
                <Image src="https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/check.svg" alt='check icon' />
              )}
            </span>
          </div>
        </div>
      </li>
      <div className=" dateinfo d-flex justify-content-start ml-4 mb-3 "> {formatMessageTime(message.created_at)}</div>
    </>
  )
}


const ReceivedMessage = ({ message, showMedia, hideMedia, toggleMedia }) => {
  return (
    <>
      {message.assets && message.assets.length > 0 ? (
        <>
          <Row>
            <Col xs={2} sm={2} md={1} lg={1}>
              <div className="imgchat">
                <Avatar
                  src={message.user?.picture}
                  style={{ width: "39px", height: "39px", marginLeft: "10px" }}
                  className=" img-fluid"
                  alt="avatar"
                >
                  <img
                    src={defaultProfile || "/placeholder.svg"}
                    style={{ width: "50px", height: "50px" }}
                    alt="profile"
                  />
                </Avatar>
              </div>
            </Col>
            <Col xs={10} sm={10} md={11} lg={11}>
              <div className="textchat">
                <div className="headingchat min-width-125">
                  <div className="videochat-play">
                    <Row>
                      {message.assets.map((asset, index) => (
                        <MediaPreview key={index} asset={asset} showMedia={showMedia} />
                      ))}
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Messagetext message={message} isFromReceived={true} ismediaText={true} />
        </>
      ) : (
        <Messagetext message={message} isFromReceived={true} ismediaText={false} />
      )}
      <MediaViewer toggleMedia={toggleMedia} hideMedia={hideMedia} />
    </>
  )
}

const SentMessage = ({ message, showMedia, hideMedia, toggleMedia }) => {
  return (
    <>
      {message.assets && message.assets.length > 0 ? (
        <>
          <div className="textchat mediachat">
            <div className="headingchat ">
              <div className="videochat-play bg-none">
                <Row>
                  {message.assets.map((asset, index) => (
                    <MediaPreview key={index} asset={asset} showMedia={showMedia} />
                  ))}
                </Row>
              </div>
            </div>
          </div>
          <Messagetext message={message} isFromReceived={false} ismediaText={true} />
        </>
      ) : (
        <Messagetext message={message} isFromReceived={false} ismediaText={false} />
      )}
      <MediaViewer toggleMedia={toggleMedia} hideMedia={hideMedia} />
    </>
  )
}


const MediaPreview = ({ asset, showMedia }) => {
  const videoRef = useRef(null)

  const handleClick = () => {
    showMedia(asset.file, asset.file_type.startsWith("video") ? "video" : "image")
  }

  if (asset.file_type.startsWith("image")) {
    return (
      <Col sm={6} md={3} style={{ width: "100px", height: "100px" }} className="p-0 mx-1">
        <Image
          src={asset.file || "/placeholder.svg"}
          className="imgvideo"
          style={{ width: "100%", height: "100%", borderRadius: "16px", position: "relative", cursor: "pointer" }}
          alt="media preview"
          onClick={handleClick}
        />
      </Col>
    )
  } else if (asset.file_type.startsWith("video")) {
    return (
      <Col sm={6} md={3} style={{ width: "100px" }} className="p-0 mx-1">
        <div
          style={{
            width: "100px",
            height: "100px",
            borderRadius: "16px",
            overflow: "hidden",
            cursor: "pointer",
            position: "relative",
          }}
          onClick={handleClick}
        >
          <video ref={videoRef} style={{ width: "100%", height: "100%", objectFit: "cover" }} autoPlay muted playsInline loop>
            <source src={asset.file} type="video/mp4" />
          </video>
        </div>
      </Col>
    )
  } else if (asset.file_type.startsWith("audio")) {
    return (
      <audio controls className="imgvideo">
        <source src={asset.file} />
      </audio>
    )
  }
  return null
}

const MediaViewer = ({ toggleMedia, hideMedia }) => {
  if (!toggleMedia.isOpen) return null

  if (toggleMedia.type === "image") {
    return (
      <ImageViewer
        src={[toggleMedia.file] || "/placeholder.svg"}
        disableScroll={false}
        onClose={hideMedia}
        backgroundStyle={{
          backgroundColor: "rgba(0,0,0,0.9)",
        }}
        alt="viewer"
      />
    )
  } else if (toggleMedia.type === "video") {
    return <VideoPreviewModal videoFile={toggleMedia.file} isOpen={toggleMedia.isOpen} onClose={hideMedia} />
  }
  return null
}

export default MeessageItem
